// Values set per environment at run time (the same image runs on test and prod), injected by src/app/layout.tsx.
// CLIENT_SITE_URL is read from the env on the server too, so server-rendered links match the links in the browser.
export const getRuntimeConfig = () => {
  if (typeof window === 'undefined') {
    return {
      ENABLE_FAKE_FILL: '',
      CLIENT_SITE_URL: process.env.CLIENT_SITE_URL ?? '',
    }
  }

  return {
    ENABLE_FAKE_FILL: window.__RUNTIME_CONFIG__?.ENABLE_FAKE_FILL ?? '',
    CLIENT_SITE_URL: window.__RUNTIME_CONFIG__?.CLIENT_SITE_URL ?? '',
  }
}
